import callbackCall from 'components/form/config/call';
import Form from 'components/form';
import Observer from 'common/scripts/observer';
import Popup from 'components/popup';
import Select from 'components/forms/select';
import ShowMore from 'components/show-more';
import Slider from 'components/slider';
import Tabs from 'components/tabs';

const observer = new Observer();

// Поключаем слайдер в попапе с акциями
observer.subscribe('insetContentPopup', (openPopup, instance) => {
    const sliderActionWrap = openPopup.querySelector('.j-offer-news-slider');
    const callbackSelector = openPopup.querySelector('.j-form-callback-action');

    if (sliderActionWrap) {
        const sliderAction = new Slider();

        sliderAction.init({
            slider       : sliderActionWrap,
            dots         : false,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            caption      : true,
            modify       : 'big_slide'
        });
    }

    if (callbackSelector) {
        const form = new Form();
        const select = new Select();
        const callbackSelect = callbackSelector.querySelector('.j-select');

        select.init({
            element      : callbackSelect,
            disableSearch: true
        });

        callbackCall(form, callbackSelector, instance);
    }
});

const actionPopupBtn = Array.from(document.querySelectorAll('.j-action-popup'));

const initActionsPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть форму обратной связи',
            template            : 'classic',
            templateContent     : 'action'
        };

        const popupCallback = new Popup(popupOptions);

        popupCallback.init();
    }
};

if (actionPopupBtn) {
    initActionsPopup(actionPopupBtn);

    observer.subscribe('loadProgress', (reportList, reportsLoaded) => {
        const allProgressPopupBtn = Array.from(reportList.querySelectorAll('.j-action-popup'));
        const loadedProgressPopupBtn = allProgressPopupBtn.slice(allProgressPopupBtn.length - reportsLoaded);

        initActionsPopup(loadedProgressPopupBtn);
    });
}

const actionList = Array.from(document.querySelectorAll('.j-action-list'));

if (actionList.length) {
    actionList.forEach((actionListWrap) => {
        const actionMore = actionListWrap.querySelector('.j-action-more-btn');
        const showHidden = actionListWrap.querySelector('.j-action-show-hidden');

        const options = {
            button            : actionMore,
            listWrapper       : actionListWrap,
            itemClass         : '.action__item',
            nodesAfterLastItem: 1,
            url               : actionListWrap.dataset.url ? actionListWrap.dataset.url : false
        };
        const loadBtnCount = 1;

        if (actionMore) {
            if (actionListWrap.childElementCount - loadBtnCount < 3) {
                actionMore.classList.add('is-hidden');
            }
        }

        observer.publish('loadProgress', actionListWrap, actionListWrap.childElementCount - loadBtnCount);

        if (actionMore) {
            new ShowMore(options).init();
        }

        // Для контента просто скрытого стилями
        if (showHidden) {
            showHidden.addEventListener('click', () => {
                const hiddenArr = Array.from(actionListWrap.querySelectorAll('.is-hidden'));

                hiddenArr.forEach((item) => {
                    item.classList.remove('is-hidden');
                });

                showHidden.classList.add('is-hidden');
            });
        }
    });
}

/**
 * Табы в блоке акций.
 * @type {Element}
 */
const tabsPurchaseClass = document.querySelector('.j-tabs-action');

if (tabsPurchaseClass) {
    const tabsPurchase = new Tabs();

    tabsPurchase.init({
        element             : '.j-tabs-action',
        tabsItemClass       : '.purchase-tabs__button',
        tabsContentItemClass: '.action__wrap-content'
    });
}
